const admissionSupport = {
  header1: 'Admission Info',
  billingPayment: 'Billing Payment',
  visitType: 'Visit Type',
  visitTypePlaceholder: 'Select Visit Type',
  reference: 'Reference Patient',
  referralInfo: 'Referral Info',
  partnerType: 'Partner Type',
  partnerTypePlaceholder: 'Select Partner Type',
  partner: 'Partner',
  partnerPlaceholder: 'Select Partner',
  referenceLetter: 'Reference Letter',
  referenceDate: 'Reference Date',
  diagnosis: 'Diagnosis',
  table: {
    button: {
      printLabel: 'Print Label',
      printForm: 'Print Form'
    }
  },
  modalPrintLabel: {
    header: 'Print Label'
  },
  note: 'Note',
  guaranteeInfoInsurance: 'Guarantee Info (Insurance)',
  insurance: 'Insurance',
  insurancePlaceholder: 'Select Insurance',
  insuranceNumber: 'Insurance Number',
  insuranceExpiration: 'Insurance Expiration',
  insuranceClass: 'Insurance Class',
  insuranceClassPlaceholder: 'Select Insurance Class',
  guaranteeInfoBPJS: 'Guarantee Info (BPJS)',
  BPJSNumber: 'BPJS Number',
  BPJSClass: 'BPJS Class',
  BPJSClassPlaceholder: 'Select BPJS Class'
}

export default admissionSupport
